<div class="ms-auto header-right">
  <ul class="list-unstyled">

    <!-- Location Picker Pill -->
    <li class="pc-h-item">
      <button class="loc-pill" (click)="pickerOpen = true">
        @if (loc.country) {
          <span class="loc-flag">{{ loc.country.emoji }}</span>
          <span class="loc-text">
            {{ loc.city?.name || loc.state?.name || loc.country.name }}
            @if (loc.timezoneAbbr) { · {{ loc.timezoneAbbr }} }
          </span>
        } @else {
          <i class="ti ti-map-pin"></i>
          <span class="loc-text">Select Location</span>
        }
        <i class="ti ti-chevron-down loc-chevron"></i>
      </button>
    </li>

    <!-- Bell / Notifications -->
    <li class="pc-h-item">
      <div ngbDropdown placement="bottom-end" (openChange)="onNotifDropdown($event)">
        <a class="header-icon-btn" href="javascript:" ngbDropdownToggle>
          <i class="ti ti-bell"></i>
          @if (notifUnreadCount > 0) {
            <span class="icon-badge">{{ notifUnreadCount }}</span>
          }
        </a>
        <div class="vr-notif-dropdown" ngbDropdownMenu>
          <app-notification-dropdown></app-notification-dropdown>
        </div>
      </div>
    </li>

    <!-- Messages -->
    <li class="pc-h-item">
      <a class="header-icon-btn" routerLink="/chat">
        <i class="ti ti-message"></i>
        @if (chatUnreadCount > 0) {
          <span class="icon-badge">{{ chatUnreadCount }}</span>
        }
      </a>
    </li>

    <!-- Tasks / Notes -->
    <!-- <li class="pc-h-item">
      <a class="header-icon-btn" href="javascript:" (click)="openChatNotes()">
        <i class="ti ti-clipboard-list"></i>
        <span class="icon-badge">4</span>
      </a>
    </li> -->

    <!-- User Profile -->
    <li class="pc-h-item">
      <div ngbDropdown placement="bottom-end">
        <a class="user-profile-btn" href="javascript:" ngbDropdownToggle>
          <div class="user-text">
            <span class="user-name">{{ authenticationService.currentUserName || 'Admin User' }}</span>
            <span class="user-sub">View profile</span>
          </div>
          <div class="avatar-wrap">
            <img [src]="authenticationService.currentUserAvatar" alt="user-image" class="user-avatar" />
            <span class="online-dot"></span>
          </div>
        </a>

        <div class="vr-user-dropdown" ngbDropdownMenu>
          <!-- User card header -->
          <div class="vr-ud-header">
            <img [src]="authenticationService.currentUserAvatar" alt="avatar" class="vr-ud-avatar" />
            <div class="vr-ud-info">
              <span class="vr-ud-name">{{ authenticationService.currentUserName || 'Admin User' }}</span>
              <span class="vr-ud-role">Project Admin</span>
            </div>
          </div>

          <div class="vr-ud-divider"></div>

          <!-- Menu items -->
          <a [routerLink]="['/user/accountProfile/profile']" ngbDropdownItem class="vr-ud-item">
            <span class="vr-ud-icon-wrap vr-ud-icon--blue"><i class="ti ti-user-circle mx-0"></i></span>
            <span>Account Profile</span>
          </a>
          <!-- <a [routerLink]="['/user/social-profile']" ngbDropdownItem class="vr-ud-item">
            <span class="vr-ud-icon-wrap vr-ud-icon--purple"><i class="ti ti-users"></i></span>
            <span>Social Profile</span>
          </a> -->

          <div class="vr-ud-divider"></div>

          <a href="javascript:" ngbDropdownItem class="vr-ud-item vr-ud-item--danger" (click)="logout()">
            <span class="vr-ud-icon-wrap vr-ud-icon--red"><i class="ti ti-logout mx-0"></i></span>
            <span>Logout</span>
          </a>
        </div>
      </div>
    </li>

  </ul>
</div>

<app-location-picker [open]="pickerOpen" (closed)="pickerOpen = false"></app-location-picker>
